import { AfterViewInit, Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { FormTabHeader } from "./form-tab-header.types";

@Component({
  selector: 'kt-form-tab-header',
  templateUrl: './form-tab-header.component.html',
  styleUrls: ['./form-tab-header.component.scss']
})
export class FormTabHeaderComponent implements AfterViewInit {
  private _headers$ = new BehaviorSubject<FormTabHeader[]>([])
  headers$ = this._headers$.asObservable()
  @Input()
  set headers(value: FormTabHeader[]) {
    this._headers$.next(value)
  }

  @Input() innerTop: string = null;

  selectedIndex: number = 0
  @Input()
  set selectedTabIndex(index: number) {
    this.selectedIndex = index
  }

  @Output() tabChange = new EventEmitter<number>()

  @HostBinding('style.top') top = '0px'
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.innerTop) {
      this.top = this.innerTop
      return
    }
    this.updateStickyPosition()
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (this.innerTop) {
      this.top = this.innerTop
      return
    }
    this.updateStickyPosition()
  }

  ngAfterViewInit(): void {
    if (this.innerTop) {
      this.top = this.innerTop
      return
    }
    this.updateStickyPosition()
  }

  onHeaderClick(index: number) {
    this.selectedIndex = index
    this.tabChange.emit(index)
  }

  private updateStickyPosition() {
    const topHeaderElement = document.querySelector('.header') as HTMLElement;
    const ktPortletHeaderElement = document.getElementsByTagName('kt-portlet-header').item(0) as HTMLElement;

    let height = 0;
    if (topHeaderElement != null) {
      height += topHeaderElement.offsetHeight
    }
    if (ktPortletHeaderElement != null) {
      height += ktPortletHeaderElement.offsetHeight
    }

    this.top = height + 'px'
  }
}